<template>
    <div class="whatsapp-order-type" :data-id-ref="data_id_ref">
        <div class="d-flex mb-10">
            <div class="message-text p-5 rounded text-dark fw-bold" :class="{ 'bg-danger': !message.linker_order_id }">
                <div class="details-row">
                    <div class="details-wrapper" v-if="message.linker_order_id">
                        <p class="order-num">{{ $t('Order') }} #{{ message.linker_order_id || 0 }}</p>
                        <div class="extra">
                            <span class="price">
                                {{ this.formatPrice() }} {{
                                    message.content.product_items[0].currency }}
                            </span>
                            <span class="dot"></span>
                            <span class="cat">{{ $t('products') }} {{ message.content.product_items.length }}</span>
                        </div>
                    </div>
                    <div class="details-wrapper" v-else>
                        <div class="order-num text-white">{{ $t('Order Error Msg') }}</div>
                    </div>
                </div>
                <div class="btns" v-if="message.linker_order_id">
                    <button class="generate-payment-link px-2 mb-3" @click="showOrderDetails">
                        <div>{{ $t('Order Details') }}</div>
                    </button>
                    <button class="generate-payment-link px-2" @click="sendPaymentSummary" :disabled="paymentDetailsLoading">
                        <div v-if="paymentDetailsLoading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </div>
                        <div v-else>{{ $t('Generate Payment Details') }}</div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { numberTo2DigitsAfterDecimalPoint } from '@/components/utils'

export default {
    name: "order-type",
    props: {
        message: {
            type: Object,
            required: true,
            default: () => ({ content: { product_items: [] } })
        },
        data_id_ref: Number,
        url: null
    },
    data() {
        return {
            paymentDetailsLoading: false,
        }
    },
    methods: {
        formatPrice() {
            return numberTo2DigitsAfterDecimalPoint(this?.message?.linker_order_total)
        },
        formatTimestamp(seconds) {
            let date = new Date(seconds * 1000);
            let options = { hour: 'numeric', minute: 'numeric' };
            return date.toLocaleTimeString(undefined, options) ? date.toLocaleTimeString(undefined, options).replace('AM', this.$t('AM')).replace('PM', this.$t('PM')) : '';
        },
        async sendPaymentSummary() {
            try {
                this.paymentDetailsLoading = true
                await this.$store.dispatch("Orders/sendOrderDetailsMessage",
                    { orderId: this?.message.linker_order_id });
                this.paymentDetailsLoading = false
            } catch {
                this.paymentDetailsLoading = false
            }
        },
        showOrderDetails() {
            this.$store.commit("Orders/setSelectedDetailsOrder", {
                id: this?.message.linker_order_id,
            });
        },
    },
}
</script>
<style scoped lang="scss">
@import './styles/order.scss'
</style>